import React from "react";
import { Label, Tooltip } from "@patternfly/react-core";

export const GroupsCell = ({ row, groupFilter }) => {

  const groups = Object.values(row?.groups_completed || {})
    .filter(item => !item.group_symbol?.toUpperCase().startsWith("ABS"))
    .filter(item => !groupFilter || item.group_symbol === groupFilter);

  if (!groups.length) return null;

  return (
    <>
      {groups.map(item => {
        const repetitions = item.repetitions || 0;
        const completedCount = item.completed_sheet_type?.length || 0;
        const totalExercises = item.number_of_exercises || 0;

        const tooltipText =
          repetitions > 1
            ? `Arkusz powtórzono ${item.last_update}`
            : completedCount === 0
              ? `Zrealizowano w nieznanym zakresie ${item.last_update}`
              : `Zrealizowano: [ ${item.completed_sheet_type} ] ${item.last_update}`;

        return (
          <Tooltip key={item.uid} content={<div>{tooltipText}</div>}>
            <Label
              isCompact
              // style={{ marginRight: "2px" }}
              style={{
                fontSize: "10px",
                padding: "1px 5px",
                whiteSpace: "nowrap",
                marginRight: "2px"
              }}
              color={
                repetitions > 1
                  ? "gold"
                  : completedCount >= totalExercises
                    ? "green"
                    : "gray"
              }
            >
              {item.group_symbol}
            </Label>
          </Tooltip>
        );
      })}
    </>
  );
};